import { Button, Col, Row, Spin, Typography, Form, Input } from "antd";
import React, { forwardRef, useCallback, useMemo, useState } from "react";
import _ from "lodash";
import BaseModal from "components/BaseModal";
import { LoadingIcon } from "components/Icons";
import { BASE_GUTTER } from "constants/Layout";
import { urlRegexValidator } from "utils/formUtils";
import BitBucketConfigOauthForm from "./BitBucketConfigOauthForm";
import { BitBucketCreateForm } from "./BitBucketCreateForm";

const BitBucketOauthPopUp = forwardRef((props, ref) => {
  const [selectedInstallation, setSelectedInstalltion] = useState("list");
  const [appCreated, setAppCreated] = useState(false);
  const [formData, setFormData] = useState({});
  const [form] = Form.useForm();
  const [disableBitBucketForm, setDisableBitBucketForm] = useState(true);

  const baseModalProps = {
    title: "BitBucket Oauth On-Prem Integration",
    footer: null,
  };

  const checkUrlValidation = _.debounce(async () => {
    try {
      await form.validateFields();
      setDisableBitBucketForm(false);
    } catch {
      setDisableBitBucketForm(true);
    }
  }, 500);

  const handleChange = useCallback(
    (values) => {
      setFormData((prevFormData) => ({ ...prevFormData, ...values }));
      checkUrlValidation();
    },
    [checkUrlValidation]
  );

  const showList = selectedInstallation === "list";
  const isDisable = useMemo(
    () => (showList || selectedInstallation === "new") && disableBitBucketForm,
    [disableBitBucketForm, selectedInstallation, showList]
  );

  return (
    <BaseModal
      ref={ref}
      modalProps={baseModalProps}
      afterClose={props.afterClose}
    >
      <Spin spinning={false} indicator={<LoadingIcon />}>
        <Row gutter={BASE_GUTTER}>
          {(showList || selectedInstallation === "new") && !appCreated && (
            <Col span={24}>
              <Form layout="vertical" form={form} onValuesChange={handleChange}>
                <Form.Item
                  name="hostUrl"
                  label="Host URL"
                  rules={[
                    { required: true, message: "Host Url is required" },
                    urlRegexValidator(),
                  ]}
                >
                  <Input placeholder="https://bitbucket-onprem.example.com" />
                </Form.Item>
              </Form>
            </Col>
          )}
          <Col span={24}>
            <div
              className={
                showList || selectedInstallation === "new"
                  ? "d-flex justify-content-between inline-form-item"
                  : "text-right"
              }
            >
              {(showList || selectedInstallation === "new") && (
                <Typography.Text strong>
                  {showList ? "Configuration List" : "Create Configuration"}
                </Typography.Text>
              )}
              <Button
                disabled={isDisable}
                type={showList ? "primary" : ""}
                onClick={() => {
                  setSelectedInstalltion(showList ? "new" : "list");
                  if (appCreated) {
                    setAppCreated(!appCreated);
                  }
                }}
              >
                {showList ? "Create" : "Cancel"}
              </Button>
            </div>
          </Col>
          <Col span={24}>
            {selectedInstallation === "new" && appCreated ? (
              <BitBucketConfigOauthForm
                initialValues={formData}
                afterSubmit={() => {
                  setSelectedInstalltion("list");
                }}
              />
            ) : selectedInstallation === "new" ? (
              <BitBucketCreateForm
                setAppCreated={setAppCreated}
                setFormData={setFormData}
                formData={formData}
              />
            ) : null}
          </Col>
        </Row>
      </Spin>
    </BaseModal>
  );
});

export { BitBucketOauthPopUp };
